import { VerificationNames } from "shared/types";

export const verificationLogos = {
  [VerificationNames.RentalApplication]: [
    { src: "/assets/boom_logo.svg", alt: "boom logo" }
  ],
  [VerificationNames.IdentityVerification]: [
    {
      src: "/assets/plaid_logo.svg",
      alt: "plaid logo"
    }
  ],
  [VerificationNames.VerifiedIncomeVerification]: [
    { src: "/assets/plaid_logo.svg", alt: "plaid logo" },
    {
      src: "/assets/atomic_logo.svg",
      alt: "atomic logo",
      width: 76,
      height: 20
    },
    {
      src: "/assets/pinwheel_logo.svg",
      alt: "pinwheel logo",
      width: 76,
      height: 20
    },
    {
      src: "/assets/ocrolus_logo.svg",
      alt: "ocrolus logo",
      width: 74,
      height: 22
    }
  ],
  [VerificationNames.HousingHistory]: [
    { src: "/assets/boom_logo.svg", alt: "boom logo" }
  ],
  [VerificationNames.CreditReport]: [
    {
      src: "/assets/equifax_logo.svg",
      alt: "equifax logo",
      width: 81,
      height: 14
    }
  ],
  [VerificationNames.CriminalReport]: [
    { src: "/assets/cleara_logo.svg", alt: "cleara logo" },
    { src: "/assets/cic_logo.svg", alt: "cic logo" }
  ],
  [VerificationNames.EvictionReport]: [
    { src: "/assets/cic_logo.svg", alt: "cic logo", width: 47, height: 20 }
  ]
};

export const sideImageURL = {
  [VerificationNames.RentalApplication]: "/assets/basic_information.jpg",
  [VerificationNames.IdentityVerification]: "/assets/identity_verification.png",
  [VerificationNames.VerifiedIncomeVerification]: "/assets/income_history.jpg",
  [VerificationNames.HousingHistory]: "/assets/housing_history.jpg",
  [VerificationNames.CreditReport]: "/assets/credit_report.jpg",
  [VerificationNames.CriminalReport]: "/assets/criminal_report.jpg",
  [VerificationNames.EvictionReport]: "/assets/housing_court_report.jpg",
  [VerificationNames.RentalVerification]: "/assets/rental_verification.jpg"
};

export const schemasWithConfigure = [
  VerificationNames.RentalApplication,
  VerificationNames.VerifiedIncomeVerification,
  VerificationNames.IdentityVerification,
  VerificationNames.CriminalReport,
  VerificationNames.CreditReport,
  VerificationNames.HousingHistory
];
